module.exports = __webpack_public_path__ + "img/off_en.6bd7ce5f.png";